import React, { useEffect, useState } from "react";
import { getWeather } from "@/lib/api2";
import { Cloud, CloudRain, Sun, CloudSnow, CloudFog, Zap } from "lucide-react";

const codeMap = (c) => {
  if ([0, 1].includes(c)) return { label: "CLEAR", Icon: Sun };
  if ([2, 3].includes(c)) return { label: "CLOUDY", Icon: Cloud };
  if ([45, 48].includes(c)) return { label: "FOG", Icon: CloudFog };
  if (c >= 51 && c <= 67) return { label: "RAIN", Icon: CloudRain };
  if (c >= 71 && c <= 86) return { label: "SNOW", Icon: CloudSnow };
  if (c >= 95) return { label: "STORM", Icon: Zap };
  return { label: "UNKNOWN", Icon: Cloud };
};

export default function WeatherPanel({ refreshKey, location = "London" }) {
  const [w, setW] = useState(null);
  useEffect(() => { getWeather(location).then(setW).catch(() => {}); }, [location, refreshKey]);
  if (!w) return <div className="rc-panel p-3 h-full"><div className="rc-label rc-blink">SCANNING</div></div>;
  const { label, Icon } = codeMap(w.current?.weather_code);
  return (
    <div className="rc-panel p-3 h-full flex flex-col" data-testid="weather-panel">
      <div className="flex items-center justify-between mb-2">
        <div className="rc-label">// ATMOSPHERIC</div>
        <div className="rc-label text-[9px]">{w.location?.toUpperCase()}</div>
      </div>
      <div className="flex items-center gap-3">
        <Icon size={36} className="text-[var(--rc-gold)] rc-pulse-glow" />
        <div>
          <div className="font-display text-2xl rc-glow-text tabular-nums">{Math.round(w.current?.temperature_2m)}°C</div>
          <div className="rc-label text-[10px]">{label}</div>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-1 mt-3 text-[10px]">
        {w.daily?.time?.slice(0, 3).map((d, i) => (
          <div key={d} className="border border-[var(--rc-gold-dim)] p-1 text-center">
            <div className="rc-label text-[8px]">{new Date(d).toLocaleDateString(undefined, { weekday: "short" }).toUpperCase()}</div>
            <div className="tabular-nums mt-0.5">{Math.round(w.daily.temperature_2m_max[i])}°/{Math.round(w.daily.temperature_2m_min[i])}°</div>
            <div className="text-[9px] text-[var(--rc-text-dim)]">{w.daily.precipitation_probability_max[i]}%</div>
          </div>
        ))}
      </div>
    </div>
  );
}
